.e{align-items:center;}